import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { BarChart3 } from "lucide-react";
import { PageHeader, Spinner, Card, EmptyState, Badge } from "./_ui";

export default function SondagesPanel() {
  const [polls, setPolls] = useState(null);
  useEffect(() => { api.get("/polls").then((r) => setPolls(r.data)); }, []);
  if (!polls) return (<><PageHeader title="Sondages" /><Spinner /></>);

  return (
    <div data-testid="admin-polls">
      <PageHeader
        title="Sondages"
        subtitle="Consultations citoyennes ouvertes — résultats en temps réel."
      />
      {polls.length === 0 ? (
        <EmptyState icon={BarChart3} title="Aucun sondage actif" />
      ) : (
        <div className="space-y-4">
          {polls.map((p) => {
            const open = new Date(p.closes_at) > new Date();
            return (
              <Card key={p.id} className="p-5">
                <div className="flex items-start justify-between gap-3 flex-wrap">
                  <div>
                    <h3 className="font-display text-lg text-white">{p.question}</h3>
                    <div className="text-xs text-slate-400 mt-1">{p.total_votes} votes · {p.options.length} options</div>
                  </div>
                  <Badge color={open ? "green" : "slate"}>
                    {open ? `Clôture ${new Date(p.closes_at).toLocaleDateString("fr-FR")}` : "Clos"}
                  </Badge>
                </div>
                <div className="mt-4 space-y-2">
                  {p.options.map((o) => {
                    const pct = p.total_votes ? Math.round((o.votes / p.total_votes) * 100) : 0;
                    return (
                      <div key={o.option_id}>
                        <div className="flex items-center justify-between text-xs mb-1">
                          <span className="text-slate-200">{o.label}</span>
                          <span className="text-slate-400">{o.votes} · {pct}%</span>
                        </div>
                        <div className="h-2 rounded-full bg-white/5 overflow-hidden">
                          <div className="h-full bg-gradient-to-r from-[#0052CC] to-[#D4AF37] rounded-full" style={{ width: `${pct}%` }} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
